import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const ProjectPlanList = Loadable(lazy(() => import('./ProjectPlanList')));
const AddProjectPlan = Loadable(lazy(() => import('./AddProjectPlan')));

const ProjectPlanRoutes = [
  {
    path: '/projectplan/list',
    element: <ProjectPlanList />,
    auth: authRoles.admin,
  },
  {
    path: '/projectplan/manage',
    element: <AddProjectPlan />,
    auth: authRoles.admin,
  },
];

export default ProjectPlanRoutes;
